/**
 * Preference keys that must survive auth session clears (login/logout).
 * WelcomeModal writes welcome_modal_dismissed_{userId}; clearing it would
 * show the one-time modal again on the next login.
 */
export const WELCOME_MODAL_DISMISSED_PREFIX = 'welcome_modal_dismissed_';

const PREFERENCE_KEY_PREFIXES = [WELCOME_MODAL_DISMISSED_PREFIX] as const;

const collectPreferenceEntries = (): [string, string][] => {
  const kept: [string, string][] = [];

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (!key) {
      continue;
    }

    if (
      PREFERENCE_KEY_PREFIXES.some((prefix) => key.startsWith(prefix))
    ) {
      const value = localStorage.getItem(key);
      if (value !== null) {
        kept.push([key, value]);
      }
    }
  }

  return kept;
};

/**
 * Clears auth/session localStorage while restoring UI preference keys
 * (for example welcome modal dismissed flags).
 */
export const clearLocalStoragePreservingPreferences = () => {
  const kept = collectPreferenceEntries();
  localStorage.clear();
  kept.forEach(([key, value]) => localStorage.setItem(key, value));
};
